export default "__VITE_ASSET__d698e00e__"